import { render, staticRenderFns } from "./IndicadoresMarketplaceComissao.vue?vue&type=template&id=48d6e2ca&scoped=true&"
import script from "./IndicadoresMarketplaceComissao.vue?vue&type=script&lang=js&"
export * from "./IndicadoresMarketplaceComissao.vue?vue&type=script&lang=js&"
import style0 from "./IndicadoresMarketplaceComissao.vue?vue&type=style&index=0&id=48d6e2ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d6e2ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VDivider,VIcon})
